export function init() {
    htmx.on('htmx:afterSwap', function(event) {
        if (event.target.id === 'announcements') {
            buildAnnouncement();
        }
    });
}

function buildAnnouncement() {
    const message = document.querySelector('.js-announcement');

    if (!message) {
        return false;
    }

    // When a close link is clicked:
    // – Hide the message
    // – Create a cookie for that announcement using messageid data attr
    message.querySelector('.js-close-announcement').addEventListener('click', function (e) {
        e.preventDefault();

        // Hide the message
        message.style.display= "none";
        
        let d = new Date();

        // Create a cookie for this announcement to expire 4 hours from now
        d.setTime(d.getTime() + (4 * 60 * 60 * 1000));

        document.cookie = message.dataset.id + "=true; expires=" +  d.toUTCString() +"; path=/; sameSite=Strict; Secure";
    });
}